import Meta from '@/components/common/Meta'

import SelfStorageFacilitiesNearMePage from '@/v2/components/pages/landing-pages/self-storage-facilities-near-me-page'
import { LANDING_PAGES_META_CONTENTS } from '@/v2/constants/pages/landing-pages/meta/landing-pages-meta-content'
import { metaImages, ogImages } from '@/v2/constants/pages/landing-pages/self-storage-facilities-near-me-page'

interface SelfStorageFacilitiesNearMePageProps {}

const Page: React.FC<SelfStorageFacilitiesNearMePageProps> = () => {
  return (
    <>
      <Meta
        title={
          LANDING_PAGES_META_CONTENTS.self_storage_facilities_near_me.title ??
          LANDING_PAGES_META_CONTENTS.default?.title ??
          ''
        }
        keywords={
          LANDING_PAGES_META_CONTENTS.self_storage_facilities_near_me?.keywords ??
          LANDING_PAGES_META_CONTENTS.default?.keywords ??
          ''
        }
        description={
          LANDING_PAGES_META_CONTENTS.self_storage_facilities_near_me?.description ??
          LANDING_PAGES_META_CONTENTS.default?.description ??
          ''
        }
        openGraph={{
          images: ogImages
        }}
        searchImages={metaImages}
      />

      <SelfStorageFacilitiesNearMePage />
    </>
  )
}

export default Page
